@for (item of rowItem(); track $index) {

<div
  class="grid items-center grid-cols-5 gap-4 p-4 bg-red-4 text-grey-1 max-sm:py-3 max-sm:px-2 rounded-5 max-sm:mt-2"
>
  <div class="flex items-center col-span-3 gap-4 max-sm:gap-1">
    <div
      class="animate-pulse bg-[#DDDEE0] w-[40px] h-[40px] max-sm:w-[20px] max-sm:h-[20px] border border-grey-7 border-solid rounded-full object-contain"
    ></div>

    <div class="flex w-44">
      <div class="animate-pulse bg-[#DDDEE0] w-full h-8 max-sm:h-6"></div>
    </div>
  </div>
  <div class="flex justify-end col-span-2 gap-4 max-sm:gap-2">
    <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>

    <div
      class="bg-white text-[#666666] text-center w-28 max-sm:w-16 rounded-100 px-3 py-1"
    >
      <div class="animate-pulse bg-[#DDDEE0] w-full h-4"></div>
    </div>
    <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
  </div>
</div>

@if(!withoutMatches()){
<app-skeleton-matches-list />

} }
